
/*========================================================================
* $Id: list.js 124298 2018-01-15 14:43:10Z erhard.einsiedler $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

Mindbreeze.define('utils/array',{

  // moves an entry from oldIndex to newIndex, moving following other elements forward.
  // if the array is smaller than oldIndex or newIndex it is filled with undefined values.
  move: function (array, oldIndex, newIndex) {
    this.growArrayToLength(array, oldIndex + 1);
    this.growArrayToLength(array, newIndex + 1);
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);

    return array;
  },

  growArrayToLength: function (array, length) {
    if (length > array.length) {
      array[length - 1] = undefined;
    }
    return array;
  }

});
